/**
 * FIELD_TOOLTIPS — single source of truth for tooltip text
 * across Paso 4 components.
 *
 * Each entry maps a field key to { label, tooltipText }.
 * The `tooltip(key)` helper provides safe lookup.
 */

export const FIELD_TOOLTIPS = {
  scoreCerteza: {
    label: 'Score de Certeza',
    tooltipText:
      'Indica qué tan confiables son los datos extraídos del PDF. Arriba de 80% es buen nivel. Arriba de 95% es excelente.',
  },
  mutationsIntegrityHash: {
    label: 'Hash de Integridad',
    tooltipText:
      'Código único que verifica que los datos no fueron modificados desde su carga original. No necesitás hacer nada con esto.',
  },
  estrategia: {
    label: 'Estrategia',
    tooltipText:
      'Excluir del divisor: no contar este mes en el promedio. Completar con SMVM: llenar con el salario mínimo histórico.',
  },
  categoriaMonotributo: {
    label: 'Categoría Monotributo',
    tooltipText:
      'Categoría de monotributo que declara el período. Si no estás seguro, dejá vacío y se usará la categoría más baja.',
  },
  estadoIdentidad: {
    label: 'Estado de Identidad',
    tooltipText:
      'FACTUAL = el CUIT fue validado contra ANSES. INFERRED = el CUIT se heredó de otro período.',
  },
  periodo: {
    label: 'Período',
    tooltipText:
      'Mes y año del período laboral en formato MM/AAAA.',
  },
  empresa: {
    label: 'Empresa',
    tooltipText:
      'Nombre del empleador o razón social.',
  },
  montoBruto: {
    label: 'Monto Bruto',
    tooltipText:
      'Remuneración bruta del período, sin descuentos.',
  },
  cuit: {
    label: 'CUIT',
    tooltipText:
      'Código Único de Identificación Tributaria del empleador. 11 dígitos sin guiones.',
  },
  prescripcionPanel: {
    label: 'Panel clínico de prescripción',
    tooltipText:
      'El retroactivo reclamable depende de la fecha de prescripción. Hay dos límites: administrativo (24 meses desde la prescripción) y judicial (24 meses desde la denegatoria o demanda).',
  },
  topesPeriodo: {
    label: 'Control de topes por período',
    tooltipText:
      'Art. 9 Ley 24.241: cada período tiene un tope máximo de remuneración para el cálculo del haber. Si aplicar el tope reduce el haber en más del 15%, se considera confiscatorio y no se aplica.',
  },
  advertenciaPericial: {
    label: 'Advertencia pericial estricta',
    tooltipText:
      'Los períodos de moratoria no cuentan para el promedio de PC/PAP, solo para el derecho de acceso. Para autónomos, revisar la doctrina Mackler/Volonté antes de cerrar la liquidación.',
  },
  simultaneidadDetectada: {
    label: 'Simultaneidad detectada',
    tooltipText:
      'El sistema detectó que en un mismo mes hay más de un empleador registrado. Revisá que los días y montos no estén duplicados antes de continuar.',
  },
  sueldoBrutoCargoCese: {
    label: 'Remuneración Bruta Total al Cese',
    tooltipText:
      'Si su cliente ejercía más de un cargo docente al momento del cese (por ejemplo, doble turno u horas cátedra en distintas escuelas), sume los sueldos brutos de todos los cargos simultáneos e ingrese el total aquí. La ley previsional calcula el 82% sobre la base total de los cargos ejercidos en simultáneo.',
  },
}

/**
 * Returns the tooltip entry for a given field key, or null if not found.
 *
 * @param {string} key — field key to look up
 * @returns {{ label: string, tooltipText: string } | null}
 */
export function tooltip(key) {
  return FIELD_TOOLTIPS[key] ?? null
}
